import React,  {useState, useEffect} from "react"
import './DiaCalendario.css';
  

function Calendario({dia, handleDia}){

  let correcto = localStorage.getItem("desafio"+dia) === "correcto"
  let errado = localStorage.getItem("desafio"+dia) === "errado"

  let pasta = "fechados"
  if(correcto){
    pasta = "certos"
  }else if(errado){
    pasta = "errados"
  }else{
    pasta = "fechados" 
  }


  const [data, setData] = useState([{}])

  useEffect(() => {
    fetch("https://www.araquelexplica-te.pt/custom/natal2022/calendario.php").then(
      res => res.json()
    ).then(
      data => {
        setData(data)
      }
    )
  }, [])
  return(
    <div>
      {(typeof data.desafios === 'undefined')? (
        <p>A carregar...</p>
      ):(
            <div class="dia-calendario">
                <img src={"https://www.araquelexplica-te.pt/custom/natal2022/static/"+pasta+"/dia"+dia+".png"} alt={"Dia "+dia} class="image" width="100%" onClick={() => handleDia(dia)}></img>
            </div>
      )}

    </div>
  )
}

export default Calendario